module.exports = __webpack_public_path__ + "static/media/instagram_sm.16154e420b58025093b7530e64db8f21.svg";